import { requireService } from '@profgeosoft/di-ez';
import { RadioButtonGroup } from '@repo/go-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

const ThemeSwitcher = wrap(function ThemeSwitcher() {
  const themeService = requireService('themeService');
  const { t } = useTranslation('common');

  const groupItems = useMemo(() => {
    return [
      { label: t('theme.dark'), value: 'dark' },
      { label: t('theme.light'), value: 'light' },
    ];
  }, [t]);

  return <RadioButtonGroup size="m" value={themeService.theme} items={groupItems} onChange={themeService.toggle} />;
});

export default ThemeSwitcher;
